// extracted by mini-css-extract-plugin
export default {"ChatWidget":"lEtd7QMr","buttonBack":"LFpbIQC5"};
    if(module.hot) {
      // 1764331288109
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  